import { scripts } from '@ps/bridge/qc/scripts'
import gameIframe from '@ps/bridge/iframe/iframe'
import qc from 'qc'
import _ from 'lodash'
import { adaptePictureSize, getImageRelativeUrl } from './play-component'
import generateId from '@com/utils/generate-id'
import store from '@ps/store'
import {
  setNodeStyleMerge,
  setNodeStyleMergeVH,
} from '@ps/bridge/qc/node/layout'
import assets from '@ps/bridge/qc/assets'

export enum GridAlignType {
  Normal = 1,
  ColDisLocation = 2,
  RowDisLocation = 3,
}

export enum ShelvesImageType {
  Grid = 'gridImage',
  Shelves = 'shelvesImage',
  Goods = 'goodsImageList',
  CloseGrid = 'closeGridImage',
}

export enum ShelfEliminateState {
  /** 保持货柜 */
  RetainShelf = 0,
  /** 关闭货柜 */
  CloseShelf = 1,
  /** 销毁货柜 不掉落 */
  DestroyShelfDisableFall = 2,
  /** 销毁货柜 掉落 （备注:横竖屏布局不一致时不支持掉落玩法）*/
  DestroyShelfEnableFall = 3,
}

export const DefaultHighLightColor = 'rgba(243, 173, 2, 1)' // 默认外发光颜色
export const DefaultHighLightBlur = 20 // 默认外发光模糊值
// 货架三消组件
export const isShelvesNode = (node: qc.Node): boolean => {
  if (!node) {
    return false
  }
  const iframeWindow = gameIframe.iframe
  if (iframeWindow && iframeWindow.ps && iframeWindow.ps.ShelvesComponent) {
    const shelves = node.getScript(scripts.shelves.name)
    if (shelves) {
      return true
    }
  }
  return false
}
// 格子图片数据格式
export function cookImage(node: qc.Node) {
  let url = _.get(node, 'texture.atlas.img.currentSrc') || ''
  const binUrl = _.get(node, 'texture.atlas.url') || ''
  url = getImageRelativeUrl(url, binUrl)
  const id = generateId()
  node.resetNativeSize()
  const res = {
    id,
    imageUrl: url,
    binUrl: binUrl,
    imageName: node.name,
    width: node.width,
    height: node.height,
    scaleX: 1,
    scaleY: 1,
    pivotX: 0.5,
    pivotY: 0.5,
    weight: 0,
    ext: {
      filters: {
        // 滤镜
        blur: 0,
        hue: 0,
        luminance: 0,
        saturation: 0,
      },
      oriResource: [url], // 原图png路径
    },
  }
  return res
}
// 替换切割图片
export function replaceImage(oriData, newData) {
  const res = Object.assign(oriData, {
    imageUrl: newData.imageUrl,
    binUrl: newData.binUrl,
    width: newData.width,
    height: newData.height,
    scaleX: 1,
    scaleY: 1,
    pivotX: 0.5,
    pivotY: 0.5,
    ext: {
      filters: {
        // 滤镜
        blur: 0,
        hue: 0,
        luminance: 0,
        saturation: 0,
      },
      oriResource: [newData.imageUrl], // 原图png路径
    },
  })
  return res
}
// 特定玩法格子
export function makePlayFuncGrid(data) {
  const id = generateId()
  const res = {
    id,
    name: data.name,
    nameEn: data.name,
    color: 'rgba(10, 180, 17, 0.50)',
    grid: [], // 暂不使用 { x, y, index }
  }
  return res
}
export async function makeFinalGridBoard() {
  const componentNode = store.state.workspace.shelves.componentNode
  const shelvesComponent = componentNode.getScript(scripts.shelves.name)
  const mapData = store.state.workspace.shelves.mapData
  const pdefWidth = mapData.wholeWidth
  const pdefHeight = mapData.wholeHeight
  const ldefWidth = mapData.gridWidth * mapData.row
  const ldefHeight = mapData.gridHeight * mapData.column
  // if (mapData.alignType === GridAlignType.ColDisLocation) {
  //   pdefWidth += mapData.gridWidth / 2
  //   ldefHeight += mapData.gridHeight / 2
  // } else if (mapData.alignType === GridAlignType.RowDisLocation) {
  //   pdefHeight += mapData.gridHeight / 2
  //   ldefWidth += mapData.gridWidth / 2
  // }
  componentNode.width = pdefWidth
  componentNode.height = pdefHeight
  if (mapData.reverseRowCol) {
    setNodeStyleMergeVH(componentNode, {
      pdef: {
        width: pdefWidth,
        height: pdefHeight,
      },
      ldef: {
        width: ldefWidth,
        height: ldefHeight,
      },
    })
  } else {
    setNodeStyleMerge(componentNode, {
      width: pdefWidth,
      height: pdefHeight,
    })
  }

  componentNode.removeChildren()
  // 货柜背景图
  if (mapData.shelvesImage) {
    const bgImage = gameIframe.qcGame.add.image(componentNode)
    bgImage.name = 'bgImage'
    const asset = await assets.load({ url: mapData.shelvesImage.binUrl })
    const Texture = gameIframe.qc.Texture
    bgImage.texture = new Texture(asset, 0)
    bgImage.width = mapData.shelvesImage.width
    bgImage.height = mapData.shelvesImage.height
    bgImage.x = 0
    bgImage.y = 0
    bgImage.x +=
      (0.5 - mapData.shelvesImage.pivotX) * mapData.shelvesImage.width
    bgImage.y +=
      (0.5 - mapData.shelvesImage.pivotY) * mapData.shelvesImage.height
    bgImage.scaleX = mapData.shelvesImage.scaleX
    bgImage.scaleY = mapData.shelvesImage.scaleY
    setNodeStyleMerge(bgImage, {
      x: bgImage.x,
      y: bgImage.y,
      width: mapData.shelvesImage.width,
      height: mapData.shelvesImage.height,
      scaleX: mapData.shelvesImage.scaleX,
      scaleY: mapData.shelvesImage.scaleY,
    })
  }
  const gridContainer = gameIframe.qcGame.add.node(componentNode)
  gridContainer.name = 'gridContainer'
  gridContainer.width = pdefWidth
  gridContainer.height = pdefHeight
  gridContainer.x = 0
  gridContainer.y = 0
  if (mapData.reverseRowCol) {
    setNodeStyleMergeVH(gridContainer, {
      pdef: {
        x: gridContainer.x,
        y: gridContainer.y,
        width: pdefWidth,
        height: pdefHeight,
      },
      ldef: {
        x: gridContainer.x,
        y: gridContainer.y,
        width: ldefWidth,
        height: ldefHeight,
      },
    })
  } else {
    setNodeStyleMerge(gridContainer, {
      x: gridContainer.x,
      y: gridContainer.y,
      width: pdefWidth,
      height: pdefHeight,
    })
  }

  for (let i = 0; i < mapData.row; i++) {
    for (let j = 0; j < mapData.column; j++) {
      const gridNode = gameIframe.qcGame.add.node(gridContainer)
      gridNode.name = 'gridNode'
      gridNode.width = mapData.gridWidth
      gridNode.height = mapData.gridHeight
      gridNode.visible = mapData.gridData[i][j].active
      let pdefX =
        mapData.gridWidth / 2 + j * mapData.gridWidth - mapData.wholeWidth / 2
      let pdefY =
        mapData.gridHeight / 2 +
        i * mapData.gridHeight -
        mapData.wholeHeight / 2
      if (mapData.alignType === GridAlignType.ColDisLocation && i % 2 === 1) {
        pdefX += mapData.gridWidth / 2
      }
      if (mapData.alignType === GridAlignType.RowDisLocation && j % 2 === 1) {
        pdefY += mapData.gridHeight / 2
      }
      if (mapData.reverseRowCol) {
        let ldefX =
          mapData.gridWidth / 2 +
          i * mapData.gridWidth -
          (mapData.gridWidth * mapData.row) / 2
        let ldefY =
          mapData.gridHeight / 2 +
          j * mapData.gridHeight -
          (mapData.gridHeight * mapData.column) / 2
        if (mapData.alignType === GridAlignType.ColDisLocation && i % 2 === 1) {
          ldefY += mapData.gridHeight / 2
        }
        if (mapData.alignType === GridAlignType.RowDisLocation && j % 2 === 1) {
          ldefX += mapData.gridWidth / 2
        }
        setNodeStyleMergeVH(gridNode, {
          pdef: {
            x: pdefX,
            y: pdefY,
            width: mapData.gridWidth,
            height: mapData.gridHeight,
          },
          ldef: {
            x: ldefX,
            y: ldefY,
            width: mapData.gridWidth,
            height: mapData.gridHeight,
          },
        })
      } else {
        setNodeStyleMerge(gridNode, {
          x: pdefX,
          y: pdefY,
          width: mapData.gridWidth,
          height: mapData.gridHeight,
        })
      }
      // 格子图片
      if (mapData.gridImage) {
        const gridImage = gameIframe.qcGame.add.image(gridNode)
        const asset = await assets.load({
          url: mapData.gridImage.binUrl,
        })
        const Texture = gameIframe.qc.Texture
        gridImage.texture = new Texture(asset, 0)
        gridImage.name = 'gridImage'
        gridImage.resetNativeSize()
        const { width, height } = adaptePictureSize(
          gridImage.width,
          gridImage.height,
          mapData.gridWidth,
          mapData.gridHeight,
        )
        gridImage.width = width
        gridImage.height = height
        gridImage.x = 0
        gridImage.y = 0
        gridImage.scaleX = mapData.gridImage.scaleX
        gridImage.scaleY = mapData.gridImage.scaleY
        setNodeStyleMerge(gridImage, {
          x: gridImage.x,
          y: gridImage.y,
          width: gridImage.width,
          height: gridImage.height,
          scaleX: gridImage.scaleX,
          scaleY: gridImage.scaleY,
        })
      }
      for (let k = 0; k < mapData.goodsNumInGrid; k++) {
        const subGridNode = gameIframe.qcGame.add.node(gridNode)
        subGridNode.name = 'subGridNode'
        subGridNode.width =
          (mapData.gridWidth - mapData.paddingLeft - mapData.paddingRight) /
          mapData.goodsNumInGrid
        subGridNode.height =
          mapData.gridHeight - mapData.paddingUp - mapData.paddingDown
        if (mapData.goodsNumInGrid === 2) {
          if (k === 0) {
            subGridNode.x = -subGridNode.width / 2
          } else if (k === 1) {
            subGridNode.x = subGridNode.width / 2
          }
        } else if (mapData.goodsNumInGrid === 3) {
          if (k === 0) {
            subGridNode.x = -subGridNode.width
          } else if (k === 1) {
            subGridNode.x = 0
          } else if (k === 2) {
            subGridNode.x = subGridNode.width
          }
        }
        subGridNode.y = 0
        setNodeStyleMerge(subGridNode, {
          x: subGridNode.x,
          y: subGridNode.y,
          width: subGridNode.width,
          height: subGridNode.height,
        })
        if (mapData.gridData[i][j].subGrids[k].resId) {
          const index = mapData.goodsImageList.findIndex(
            (item) => item.id === mapData.gridData[i][j].subGrids[k].resId,
          )
          const groupNode = gameIframe.qcGame.add.node(subGridNode)
          groupNode.name = 'groupNode'
          groupNode.x = 0
          groupNode.y = 0
          groupNode.width = subGridNode.width
          groupNode.height = subGridNode.height
          const goodsImage = gameIframe.qcGame.add.image(groupNode)
          const asset = await assets.load({
            url: mapData.goodsImageList[index].binUrl,
          })
          const Texture = gameIframe.qc.Texture
          goodsImage.texture = new Texture(asset, 0)
          goodsImage.name = 'goodsImage'
          goodsImage.resetNativeSize()
          const { width, height } = adaptePictureSize(
            goodsImage.width,
            goodsImage.height,
            subGridNode.width,
            subGridNode.height,
          )
          goodsImage.width = width
          goodsImage.height = height
          goodsImage.x = 0
          goodsImage.y = subGridNode.height / 2
          goodsImage.scaleX = mapData.goodsImageList[index].scaleX
          goodsImage.scaleY = mapData.goodsImageList[index].scaleY
          goodsImage.pivotY = 1
          setNodeStyleMerge(goodsImage, {
            x: goodsImage.x,
            y: goodsImage.y,
            width: goodsImage.width,
            height: goodsImage.height,
            scaleX: goodsImage.scaleX,
            scaleY: goodsImage.scaleY,
            pivotY: 1,
          })
          // if (mapData.highlight) {
          //   const { glowImg, bmd } = shelvesComponent.drawImageWithGlow(
          //     goodsImage,
          //     goodsImage.parent,
          //     mapData.highlightColor,
          //     mapData.highlightBlur,
          //   )
          //   glowImg.name = 'glow'
          //   glowImg.width = bmd.width
          //   glowImg.height = bmd.height
          //   glowImg.x = 0
          //   glowImg.y =
          //     subGridNode.height / 2 + mapData.highlightBlur * goodsImage.scaleY
          //   glowImg.scaleX = goodsImage.scaleX
          //   glowImg.scaleY = goodsImage.scaleY
          //   glowImg.pivotY = 1
          //   setNodeStyleMerge(glowImg, {
          //     x: glowImg.x,
          //     y: glowImg.y,
          //     width: glowImg.width,
          //     height: glowImg.height,
          //     scaleX: glowImg.scaleX,
          //     scaleY: glowImg.scaleY,
          //     pivotY: 1,
          //   })
          //   glowImg.parent.setChildIndex(glowImg, 0)
          // }
        }
      }
      // 关闭图片
      if (mapData.closeGridImage) {
        const closeGridImage = gameIframe.qcGame.add.image(gridNode)
        const asset = await assets.load({
          url: mapData.closeGridImage.binUrl,
        })
        const Texture = gameIframe.qc.Texture
        closeGridImage.texture = new Texture(asset, 0)
        closeGridImage.name = 'closeGridImage'
        closeGridImage.resetNativeSize()
        const { width, height } = adaptePictureSize(
          closeGridImage.width,
          closeGridImage.height,
          mapData.gridWidth,
          mapData.gridHeight,
        )
        closeGridImage.width = width
        closeGridImage.height = height
        closeGridImage.x = 0
        closeGridImage.y = 0
        closeGridImage.scaleX = mapData.closeGridImage.scaleX
        closeGridImage.scaleY = mapData.closeGridImage.scaleY
        if (mapData.gridData[i][j].closeGridImage) {
          closeGridImage.visible = true
        } else {
          closeGridImage.visible = false
        }
        setNodeStyleMerge(closeGridImage, {
          x: closeGridImage.x,
          y: closeGridImage.y,
          width: closeGridImage.width,
          height: closeGridImage.height,
          scaleX: closeGridImage.scaleX,
          scaleY: closeGridImage.scaleY,
        })
      }
    }
  }
}
// 保存mapData到脚本中
export function saveMapData2ShelvesComponent() {
  const componentNode = store.state.workspace.shelves.componentNode
  const mapData = store.state.workspace.shelves.mapData
  const shelvesComponent = componentNode.getScript(scripts.shelves.name)
  shelvesComponent.psConfig = _.cloneDeep(mapData)
  let elimateState
  if (mapData.removeReal) {
    if (mapData.fallReal) {
      elimateState = ShelfEliminateState.DestroyShelfEnableFall
    } else {
      elimateState = ShelfEliminateState.DestroyShelfDisableFall
    }
  } else {
    if (mapData.closeReal) {
      elimateState = ShelfEliminateState.CloseShelf
    } else {
      elimateState = ShelfEliminateState.RetainShelf
    }
  }
  const datas = []
  const gridContainer = componentNode.getChild('gridContainer')
  for (let i = 0; i < mapData.row; i++) {
    const rowData = []
    for (let j = 0; j < mapData.column; j++) {
      const index = i * mapData.column + j
      const data = {
        closeShelf: Boolean(mapData.gridData[i][j].closeGridImage),
        isActive: mapData.gridData[i][j].active,
        node: gridContainer.children[index].uuid,
        gridList: [],
      }
      for (let k = 0; k < mapData.goodsNumInGrid; k++) {
        let node
        if (mapData.gridImage) {
          // 格子图片是children[0]
          node = gridContainer.children[index].children[k + 1]
        } else {
          node = gridContainer.children[index].children[k]
        }
        const subData = {
          node: node.uuid,
          specailIdentifier: mapData.gridData[i][j].subGrids[k].playFuncGridId,
        }
        if (mapData.gridData[i][j].subGrids[k].resId) {
          subData.itemConfig = {
            node: node.getChild('goodsImage').uuid,
            type: mapData.gridData[i][j].subGrids[k].resId,
          }
        }
        data.gridList.push(subData)
      }
      rowData.push(data)
    }
    datas.push(rowData)
  }
  shelvesComponent.gridConfig = {
    rowCount: mapData.row,
    colCount: mapData.column,
    glowColor: mapData.highlightColor,
    glowSize: mapData.highlightBlur,
    elimateState: elimateState,
    datas: datas,
  }
}
// 选中的资源是否特定玩法格子
export function resourceSelectedIsPlayFuncGrid(): boolean {
  const mapData = store.state.workspace.shelves.mapData
  if (!mapData.resourceSelected) {
    return false
  }
  const index = mapData.playFuncGridList.findIndex(
    (item) => item.id === mapData.resourceSelected.id,
  )
  return index > -1
}
// 计算每个商品的数量
export function calGoodsNum() {
  const mapData = store.state.workspace.shelves.mapData
  const count = {}
  for (let i = 0; i < mapData.row; i++) {
    for (let j = 0; j < mapData.column; j++) {
      // 勾选了的有效格子才计算
      if (mapData.gridData[i][j].active) {
        for (let k = 0; k < mapData.goodsNumInGrid; k++) {
          if (mapData.gridData[i][j].subGrids[k].resId) {
            if (!count[mapData.gridData[i][j].subGrids[k].resId]) {
              count[mapData.gridData[i][j].subGrids[k].resId] = 0
            }
            count[mapData.gridData[i][j].subGrids[k].resId]++
          }
        }
      }
    }
  }
  for (const i in mapData.goodsImageList) {
    let num = count[mapData.goodsImageList[i].id]
    if (!num) {
      num = 0
    }
    mapData.goodsImageList[i].count = num
  }
}
// 按权重随机摆放商品
export function placeGoodsToGridByWeight() {
  const mapData = store.state.workspace.shelves.mapData
  let list = mapData.goodsImageList.map((item) => {
    return {
      id: item.id,
      weight: item.weight,
      count: 0,
    }
  })
  // 过滤掉权重为0的商品
  list = list.filter((item) => item.weight)
  // 商品列表按照权重降序排序
  const ran = Math.floor(Math.random() * 2)
  const arr = [-1, 1]
  list.sort((a, b) => {
    if (a.weight > b.weight) {
      return -1
    } else if (a.weight < b.weight) {
      return 1
    }
    // 相同权重值随机返回-1,1
    return arr[ran]
  })
  // 计算有效格子总数
  let totalGrid = 0
  for (let i = 0; i < mapData.row; i++) {
    for (let j = 0; j < mapData.column; j++) {
      if (mapData.gridData[i][j].active) {
        totalGrid += mapData.goodsNumInGrid
      }
    }
  }
  // 计算当前的商品总数
  function calCurSum() {
    let sum = 0
    for (let i = 0; i < list.length; i++) {
      sum += list[i].count
    }
    return sum
  }
  // 商品太多不够格子放，优先放高权重的商品
  if (list.length * mapData.goodsNumInGrid > totalGrid) {
    for (let i = 0; i < list.length; i++) {
      list[i].count += mapData.goodsNumInGrid
      if (calCurSum() >= totalGrid) {
        break
      }
    }
  } else {
    // 按权重和格子总数计算商品个数，向上取整
    for (let i = 0; i < list.length; i++) {
      list[i].count = Math.ceil((totalGrid * list[i].weight) / 100)
      // 确保每个商品数量是goodsNumInGrid的整数倍
      while (list[i].count % mapData.goodsNumInGrid !== 0) {
        list[i].count++
      }
    }
    // 按每个商品的权重降序依次减每个商品数量，确保商品总数等于格子总数
    for (let i = 0; i < list.length; i++) {
      const sum = calCurSum()
      if (sum > totalGrid) {
        list[i].count -= mapData.goodsNumInGrid
        if (list[i].count < 0) {
          console.error('商品个数小于0', list)
          return
        }
      } else {
        break
      }
    }
  }
  // 数量校验
  for (let i = 0; i < list.length; i++) {
    if (list[i].count < 0) {
      console.error('商品个数小于0', list)
      return
    }
  }
  if (calCurSum() > totalGrid) {
    console.error('商品个数大于格子总数', list)
    return
  }
  console.log(list)
  // 提取商品到数组中
  const goodsList: string[] = []
  list.forEach((item) => {
    for (let i = 0; i < item.count; i++) {
      goodsList.push(item.id)
    }
  })
  // 提取有效格子到数组中
  const gridList = []
  for (let i = 0; i < mapData.row; i++) {
    for (let j = 0; j < mapData.column; j++) {
      if (mapData.gridData[i][j].active) {
        for (let k = 0; k < mapData.goodsNumInGrid; k++) {
          gridList.push({
            i,
            j,
            k,
          })
        }
      }
    }
  }
  // 随机把商品放进格子中
  for (let i = 0; i < totalGrid; i++) {
    const index = Math.floor(Math.random() * gridList.length)
    mapData.gridData[gridList[index].i][gridList[index].j].subGrids[
      gridList[index].k
    ].resId = goodsList[i]
    gridList.splice(index, 1)
  }
}
